import {rotateSeats} from "./TableHelper";
import {llenarInputsUTM} from "./Actions";

const base = window.location.href.includes("localhost") ? "http://street_giving.test/" : "https://savethechildrenmx.org/"
const event = 3;

function formatCurrency(amount) {
    return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
    }).format(amount);
}

const handleTableClick = (evt) => {
    var table = evt.target;

    while (!table.classList.contains("table-container")) {
        table = table.parentElement;
    }

    if (table.querySelectorAll(".asiento-0").length > 0) {
        document.getElementById("total").value = document.getElementById("precio").value
        document.querySelector(".total").textContent = formatCurrency(document.getElementById("precio").value);
        document.getElementById("mesa").value = table.getAttribute("table_id")
        document.getElementById("mesa").previousElementSibling.textContent = table.getAttribute("table_name")
        document.querySelector(".step-2").classList.add("selected");

        document.querySelectorAll(".table-container").forEach((el) => {
            el.classList.add("not-selected");
            el.parentElement.classList.add("hide-section")
        })

        if (document.querySelector(".obj")) {
            document.querySelector(".obj").style.opacity = 0
        }

        setTimeout(() => {
            document.querySelectorAll(".hide-section").forEach(el => {
                el.classList.add("d-none")
                el.querySelectorAll(".not-selected").forEach(elem => {
                    elem.classList.add("d-none")
                })
                document.querySelector(".obj").classList.add('d-none');
            })
        }, 100)

        setTimeout(() => {
            table.classList.remove("not-selected");
            table.classList.add("selected");
            table.parentElement.classList.add("full")
            table.parentElement.classList.remove("d-none")
            table.classList.remove("d-none")
        }, 1100)

        setTimeout(() => {
            table.parentElement.classList.remove("hide-section")
            document.querySelector(".table-container.selected .asiento-0").classList.add("preselect")
        }, 1200)
    } else {
        document.getElementById("sin-asientos").showModal()
    }
}

const searchData = () => {
    fetch(base + `api/events/${event}/sections`, {
        method: 'GET',
    }).then(res => res.json())
        .then((data) => {

            if(data.locked){
                alert("Por mal uso del sistema, hemos bloqueado tu acceso al mismo")
                window.location.reload();
            }

            const event = data
            document.querySelector(".precio").textContent = formatCurrency(event.precio)
            document.querySelector("#precio").value = event.precio

            event.sections.forEach(section => {
                var validation = section.section_type === 2
                var container = document.createElement("div")
                container.classList.add("section")
                document.querySelector(".map").appendChild(container)
                if (validation) {
                    document.querySelector(".escenario").remove()

                    var li = document.createElement("div")
                    li.classList.add("sub_section_li")
                    li.classList.add("section")
                    container.appendChild(li)

                    var obj = document.createElement("div")
                    obj.classList.add("obj")
                    obj.textContent = "ESCENARIO"
                    container.appendChild(obj)

                    var ld = document.createElement("div")
                    ld.classList.add("sub_section_ld")
                    ld.classList.add("section")
                    container.appendChild(ld)
                }

                section.tables.forEach(table => {
                    var table_container = document.createElement("div")
                    table_container.classList.add("table-container")
                    table_container.classList.add("table-" + table.id)
                    table_container.setAttribute("table_id", table.id)
                    table_container.setAttribute("table_name", table.name)

                    var element = document.createElement("div")
                    element.classList.add("table")
                    element.textContent = table.name

                    table.seats.forEach(seat => {
                        var asiento_container = document.createElement("div")
                        asiento_container.classList.add("asiento-container")

                        var asiento = document.createElement("div")
                        asiento.classList.add("asiento")
                        asiento.classList.add("asiento-"+seat.seat_status)

                        asiento_container.appendChild(asiento)
                        table_container.appendChild(asiento_container)

                    })

                    table_container.appendChild(element)
                    if (validation) {
                        container.querySelector(".sub_section_" + table.direction).appendChild(table_container)
                    } else {
                        container.appendChild(table_container)
                    }

                    table_container.addEventListener("click", handleTableClick)
                    rotateSeats(table_container)
                })

            })

        })
}

export const searchTable = () => {

    fetch(base + "api/events/lockSeats/" + document.getElementById("contraseña").value + "/search", {
        method: 'GET',
    }).then(res => res.json()).then(data => {
        if (data.table > 0) {
            document.querySelector(".step-1").classList.add("hide");
            document.querySelector(".map-container").classList.remove("hide");

            document.querySelectorAll(".table-"+data.table+" .asiento-container").forEach(table => {
                table.remove()
            })

            setTimeout(() => {
                data.seats.forEach(seat => {
                    var asiento_container = document.createElement("div")
                    asiento_container.classList.add("asiento-container")
                    var asiento = document.createElement("div")
                    asiento.classList.add("asiento")
                    asiento.classList.add("asiento-0")

                    asiento_container.appendChild(asiento)
                    document.querySelector(".table-" + data.table).appendChild(asiento_container)
                    rotateSeats(document.querySelector(".table-seats .table-container"))
                })

                document.querySelector(".step-2").classList.remove("hide");

                document.querySelector("#status").value = 4
                document.querySelector(".table-" + data.table).click()
            }, 1200)
        } else {
            document.querySelector("#table-not-found").showModal()
        }
    })
}


export const init = () => {
    searchData()
    llenarInputsUTM()
}